<script>
import API from '@/services/API.js';
import ProfileIcon from '@/components/profiles/ProfileIcon';
var sha1 = require('sha1');
import OfferIcon from '@/components/offer/OfferIcon.vue';

export default {
  name: 'SelectListItemDati',
  components: {
    ProfileIcon,
    OfferIcon,
  },
  props: {
    item:{type: Object},
  },
  computed: {
    picture: function () {
      var hash = '0';
      if (this.item.deviceManufacturer != null && this.item.deviceModel != null) {
        hash = sha1(this.item.deviceManufacturer.toLowerCase() + this.item.deviceModel.toLowerCase().replace(new RegExp(' ', 'g'), ''));
      }
      const picture = API.route(API.endpoints.datis.picture, {hash: hash});
      return picture
    },
  },
}
</script>

<template>
  <div class="d-flex align-items-center pl-1">
    <div style="width: 40px;" class="text-center mr-1">
      <img v-if="!!picture.length" :src="picture" width="40" height="40" />
      <i v-else class="fa fa-mobile fa-2x text-muted"></i>
    </div>
    <div>
      <h3 class="text-md font-weight-bold mb-1 text-md">{{ item.name }}</h3>
      <div v-if="item.profile" class="d-flex align-items-center text-gray-500 text-sm">
        <ProfileIcon :icon="item.profile.icon" class="text-xs text-gray-400 mr-1"/> <span>{{ item.profile.name }}</span>
      </div>
      <div v-else class="text-danger text-sm">
        {{ $t('profile.form.no_profile') }}
      </div>
    </div>
  </div>
</template>